export const BASE_URL='https://b2blogin-437904.el.r.appspot.com/api';
// edit
// export const BASE_URL='https://testenv.acadspace.org/api';
// export const BASE_URL='http://localhost:8080/api';
